// // src/Components/Tour/AutoStartTour.tsx
// import React, { useEffect } from "react";
// import { useTour } from "../../context/TourContext";
// import { getUserSessionDetails } from "../../services/common.service";

// const TOUR_FLAG = "app_tour_shown_v1";

// export default function AutoStartTour() {
//   const { startTour } = useTour();

//   const waitForSelector = (selector: string, timeout = 4000) =>
//     new Promise<boolean>((resolve) => {
//       const start = Date.now();
//       const id = setInterval(() => {
//         if (document.querySelector(selector)) {
//           clearInterval(id);
//           resolve(true);
//         } else if (Date.now() - start > timeout) {
//           clearInterval(id);
//           resolve(false);
//         }
//       }, 100);
//     });

//   useEffect(() => {
//     (async () => {
//       try {
//         const user = getUserSessionDetails();
//         const serverFirstLogin = !!(user && (user as any).isFirstLogin);
//         const alreadySeen = !!localStorage.getItem(TOUR_FLAG);

//         // If you don't have server flag, remove serverFirstLogin condition
//         if (!alreadySeen && serverFirstLogin) {
//           // wait for the sidebar target to mount
//           await waitForSelector('[data-tour="my-book-reviews"]', 4000).catch(() => false);

//           startTour();
//           localStorage.setItem(TOUR_FLAG, "true");
//         }
//       } catch (err) {
//         // swallow errors - don't break UX
//       }
//     })();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   return null;
// }


// src/Components/Tour/AutoStartTour.tsx
import React, { useEffect } from "react";
import { useTour } from "../../context/TourContext";
import { getUserSessionDetails } from "../../services/common.service";

const TOUR_FLAG = "app_tour_shown_v1";

export default function AutoStartTour() {
  const { startTour } = useTour();

  const waitForSelector = (selector: string, timeout = 4000) =>
    new Promise<boolean>((resolve) => {
      const start = Date.now();
      const id = setInterval(() => {
        if (document.querySelector(selector)) {
          clearInterval(id);
          resolve(true);
        } else if (Date.now() - start > timeout) {
          clearInterval(id);
          resolve(false);
        }
      }, 100);
    });

  useEffect(() => {
    (async () => {
      try {
        const user = getUserSessionDetails();
        const serverFirstLogin = !!(user && (user as any).isFirstLogin);
        const alreadySeen = !!localStorage.getItem(TOUR_FLAG);

        // If you want client-only: remove serverFirstLogin check
        if (!alreadySeen && serverFirstLogin) {
          // wait for sidebar and tabs to be present (so both steps can show in order)
          await waitForSelector('[data-tour="my-book-reviews"]', 4000).catch(() => false);
          await waitForSelector('[data-tour="review-list-tabs"]', 4000).catch(() => false);

          startTour();
          localStorage.setItem(TOUR_FLAG, "true");

          // OPTIONAL: persist on server here
          // await api.post('/users/mark-tour-seen', { tour: 'book_review_v1' });
        }
      } catch (err) {
        // don't break app on errors
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
